module.exports = __webpack_public_path__ + "static/media/dgb.425cc3cf.svg";